export interface VideoItem {
  id: string;
  title: string;
  categoryId: string;
  categoryName: string;
  coverImage: string;
  rating: number;
  year: string;
  duration: string;
  tags: string[];
  description: string;
}

export const featuredVideos: VideoItem[] = [
  {
    id: 'vid-1',
    title: '星际迷航：无尽边界',
    categoryId: 'cat-4',
    categoryName: '黑桃视频',
    coverImage: 'https://readdy.ai/api/search-image?query=Science%20fiction%20space%20movie%20poster%20style%2C%20futuristic%20spaceship%20near%20colorful%20nebula%2C%20dramatic%20cosmic%20lighting%2C%20cinematic%20movie%20poster%20aesthetic%2C%20dark%20background%20with%20bright%20stars&width=600&height=340&seq=vid-feat-01&orientation=landscape',
    rating: 8.7,
    year: '2026',
    duration: '148分钟',
    tags: ['科幻', '冒险', '太空'],
    description: '一支勇敢的探险队踏上了穿越未知星域的旅程，在浩瀚宇宙中揭开古老文明的神秘面纱。',
  },
  {
    id: 'vid-2',
    title: '长安十二时辰之月落',
    categoryId: 'cat-6',
    categoryName: '桃花视频',
    coverImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20city%20at%20night%20with%20lanterns%20and%20full%20moon%2C%20Tang%20dynasty%20architectural%20style%2C%20mysterious%20atmosphere%2C%20historical%20drama%20movie%20poster%20aesthetic&width=600&height=340&seq=vid-feat-02&orientation=landscape',
    rating: 9.1,
    year: '2026',
    duration: '156分钟',
    tags: ['古装', '悬疑', '历史'],
    description: '大唐盛世之下，一桩离奇案件牵动整个长安城，少年名探在月落之前必须找出真相。',
  },
  {
    id: 'vid-3',
    title: '甜蜜的谎言',
    categoryId: 'cat-3',
    categoryName: '糖心视频',
    coverImage: 'https://readdy.ai/api/search-image?query=Romantic%20couple%20in%20cozy%20cafe%20setting%2C%20soft%20warm%20lighting%2C%20cinematic%20romance%20movie%20style%2C%20intimate%20atmosphere%2C%20film%20poster%20aesthetic%20with%20pink%20tones&width=600&height=340&seq=vid-feat-03&orientation=landscape',
    rating: 8.3,
    year: '2026',
    duration: '118分钟',
    tags: ['爱情', '喜剧', '都市'],
    description: '一个善意谎言引发的一系列啼笑皆非的故事，最终却成就了一段美好的都市爱情。',
  },
  {
    id: 'vid-4',
    title: '极限追击',
    categoryId: 'cat-1',
    categoryName: '丝瓜视频',
    coverImage: 'https://readdy.ai/api/search-image?query=High%20speed%20car%20chase%20scene%20in%20modern%20city%2C%20action%20movie%20aesthetic%2C%20dramatic%20lighting%2C%20professional%20cinematography%2C%20intense%20thriller%20atmosphere&width=600&height=340&seq=vid-feat-04&orientation=landscape',
    rating: 8.5,
    year: '2026',
    duration: '132分钟',
    tags: ['动作', '犯罪', '悬疑'],
    description: '一名退役特工为拯救被绑架的家人，在城市中展开了一场惊心动魄的极限追逐。',
  },
];

export const getVideosByCategory = (categoryId: string, count: number = 6): VideoItem[] => {
  const allVideos: VideoItem[] = [
    ...featuredVideos,
    {
      id: 'vid-5', title: '深海迷踪', categoryId: 'cat-4', categoryName: '黑桃视频',
      coverImage: 'https://readdy.ai/api/search-image?query=Deep%20ocean%20underwater%20mysterious%20scene%2C%20dark%20blue%20water%20with%20light%20rays%2C%20submarine%20adventure%2C%20cinematic%20movie%20poster%2C%20suspenseful%20deep%20sea%20atmosphere&width=600&height=340&seq=vid-05&orientation=landscape',
      rating: 8.1, year: '2025', duration: '125分钟', tags: ['科幻', '冒险', '深海'], description: '深海科考队在一次例行探测中发现了令人震惊的海底遗迹，未知的危险随之而来。',
    },
    {
      id: 'vid-6', title: '花间提壶方大厨', categoryId: 'cat-3', categoryName: '糖心视频',
      coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20cuisine%20cooking%20scene%2C%20beautiful%20food%20presentation%2C%20ancient%20Chinese%20kitchen%2C%20warm%20lighting%2C%20gourmet%20food%20photography%2C%20film%20poster%20style&width=600&height=340&seq=vid-06&orientation=landscape',
      rating: 8.8, year: '2025', duration: '45分钟/集', tags: ['美食', '古装', '爱情'], description: '一位厨艺高超的女子在古代开设酒楼，用美食征服了整座城池，也俘获了王爷的心。',
    },
    {
      id: 'vid-7', title: '云霄之上', categoryId: 'cat-6', categoryName: '桃花视频',
      coverImage: 'https://readdy.ai/api/search-image?query=Martial%20arts%20warrior%20on%20misty%20mountain%20peak%2C%20traditional%20Chinese%20landscape%20painting%20style%2C%20dramatic%20clouds%2C%20cinematic%20wuxia%20movie%20poster&width=600&height=340&seq=vid-07&orientation=landscape',
      rating: 8.6, year: '2026', duration: '142分钟', tags: ['武侠', '奇幻', '冒险'], description: '少年剑客踏上寻找传说中的云端仙境的旅程，在磨砺中领悟真正的武道精神。',
    },
    {
      id: 'vid-8', title: '时光邮局', categoryId: 'cat-1', categoryName: '丝瓜视频',
      coverImage: 'https://readdy.ai/api/search-image?query=Vintage%20post%20office%20with%20warm%20golden%20light%2C%20nostalgic%20atmosphere%2C%20letters%20and%20time%20travel%20theme%2C%20cinematic%20movie%20poster%20aesthetic%2C%20emotional%20drama%20style&width=600&height=340&seq=vid-08&orientation=landscape',
      rating: 9.0, year: '2025', duration: '110分钟', tags: ['奇幻', '剧情', '治愈'], description: '一封来自过去的信改变了一个年轻人的命运，时光邮局连接着两个时代的温暖故事。',
    },
    {
      id: 'vid-9', title: '魔法学院：新生降临', categoryId: 'cat-5', categoryName: '妖精视频',
      coverImage: 'https://readdy.ai/api/search-image?query=Magical%20academy%20castle%20with%20glowing%20spells%2C%20fantasy%20movie%20poster%2C%20young%20wizards%2C%20mystical%20atmosphere%2C%20cinematic%20lighting%2C%20enchanting%20dark%20background&width=600&height=340&seq=vid-09&orientation=landscape',
      rating: 8.4, year: '2026', duration: '138分钟', tags: ['奇幻', '魔法', '校园'], description: '一个普通少年意外收到魔法学院的录取通知书，从此踏上了精彩的魔法学习之旅。',
    },
    {
      id: 'vid-10', title: '都市夜话', categoryId: 'cat-2', categoryName: '蓝莓视频',
      coverImage: 'https://readdy.ai/api/search-image?query=Modern%20city%20night%20skyline%20with%20neon%20lights%2C%20urban%20lifestyle%20documentary%20style%2C%20cinematic%20cityscape%2C%20warm%20street%20lights%2C%20contemporary%20atmosphere&width=600&height=340&seq=vid-10&orientation=landscape',
      rating: 8.2, year: '2026', duration: '100分钟', tags: ['都市', '剧情', '生活'], description: '深夜城市中，五个陌生人的故事在24小时内交织在一起，展现了都市生活的温暖与孤独。',
    },
    {
      id: 'vid-11', title: '妖兽都市', categoryId: 'cat-5', categoryName: '妖精视频',
      coverImage: 'https://readdy.ai/api/search-image?query=Fantasy%20city%20with%20mythical%20creatures%20roaming%20streets%2C%20neon%20and%20magic%20blend%2C%20urban%20fantasy%20movie%20poster%2C%20dark%20moody%20atmosphere&width=600&height=340&seq=vid-11&orientation=landscape',
      rating: 8.0, year: '2025', duration: '128分钟', tags: ['奇幻', '都市', '妖兽'], description: '在现代都市的暗处，妖兽与人类共存的世界中，一场关乎两个种族命运的较量悄然展开。',
    },
    {
      id: 'vid-12', title: '山河锦绣', categoryId: 'cat-2', categoryName: '蓝莓视频',
      coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20landscape%20with%20rivers%20and%20mountains%2C%20traditional%20painting%20style%2C%20documentary%20film%20poster%2C%20majestic%20nature%2C%20cinematic%20wide%20shot&width=600&height=340&seq=vid-12&orientation=landscape',
      rating: 9.2, year: '2026', duration: '95分钟', tags: ['纪录片', '自然', '文化'], description: '一部展现中国壮美山河和多元文化的纪录片，每一帧都是可以当壁纸的视觉盛宴。',
    },
  ];
  return allVideos.filter(v => v.categoryId === categoryId).slice(0, count);
};

export const getAllVideos = (): VideoItem[] => {
  return featuredVideos;
};